"use client";

import { SectionShell } from "./SectionShell";

interface TextSectionProps {
  title: string;
  body: string;
}

/** Shared shape for the sections that are, for now, just a heading and a blurb. */
export function TextSection({ title, body }: TextSectionProps) {
  return (
    <SectionShell>
      <h2 className="font-display text-4xl lg:text-5xl text-text-on-background">
        {title}
      </h2>
      <p className="mt-6 text-base lg:text-lg leading-relaxed text-text-on-background/80">
        {body}
      </p>
    </SectionShell>
  );
}
